// extracted by mini-css-extract-plugin
module.exports = {"root":"UserList_root__2AcnI","title_text":"UserList_title_text__1qOB4"};